import $ from 'jquery';
import preloaded from '../src/preloaded.js';

const DELAY = 15000;

function fetch(url) {
  $.getJSON(preloaded.score_refresh_url).done(data => {
    $('.AwayTeamScore').text(data.away_team_score);
    $('.HomeTeamScore').text(data.home_team_score);
    if (data.extended_info_summary) {
      $('#ExtendedScoreSummary').text(data.extended_info_summary);
    }
    setTimeout(() => {
      fetch(url);
    }, DELAY);
  });
}

if (preloaded.score_refresh_url) {
  fetch(preloaded.score_refresh_url);
}
